import React, { useState } from "react";

import Button from "components/ui/button/Button";
import Tooltip from "components/ui/tooltip/Tooltip";
import { useAllSuppliersSaved } from "lib/hooks/api/signals/useAllSuppliersSaved";
import { SuppliersModal } from "./SuppliersModal";

type Props = {
  supplierGuids: string[];
};

function BulkSaveNoticeSupplier({ supplierGuids }: Props) {
  const [open, setOpen] = useState(false);

  const { allSaved, isLoading } = useAllSuppliersSaved(supplierGuids);

  const onOpenChange = (open: boolean) => {
    setOpen(open);
  };

  const tooltip = `Save ${supplierGuids.length} suppliers as a competitor or partner`;

  return (
    <div>
      <SuppliersModal open={open} onOpenChange={onOpenChange} guids={supplierGuids} />
      <Tooltip content={tooltip}>
        <Button
          buttonType="secondary"
          icon="bookmark"
          aria-label={tooltip}
          // Square, to match the single-supplier button beside it
          width={32}
          // Without a fill the bookmark inherits one and renders solid, which reads as saved.
          iconProps={{ fill: isLoading || !allSaved ? "transparent" : "sysPrimaryDefault" }}
          loading={isLoading}
          onClick={() => onOpenChange(true)}
        />
      </Tooltip>
    </div>
  );
}

export default BulkSaveNoticeSupplier;
